// Webpack Imports
import * as bootstrap from "bootstrap";

//Splie animation

// import { Application } from "@splinetool/runtime";

// if (window.location.pathname == "/") {
// const canvas = document.getElementById('canvas3d');
// const app = new Application(canvas);
// app.load('scene.splinecode', {
//   credentials: 'include',
//   mode: 'no-cors',
// });
//--------------------
// const canvas = document.getElementById('canvas3d');
// const app = new Application(canvas);
// app.load('scene.splinecode');
// }

//console.log('toto');

(function () {
  "use strict";

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})();

// ====== MASTERS:

AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  //offset: 160, // offset (in px) from the original trigger point
  offset: 0,
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 1200, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});

//Draggable Map (https://interactjs.io/)
const position = { x: 0, y: 0 };

interact(".map").draggable({
  inertia: true,
  startAxis: "x",
  lockAxis: "x",

  //keep the element within the area of it's parent
  modifiers: [
    interact.modifiers.restrictRect({
      restriction: "parent",
      endOnly: true,
    }),
  ],

  listeners: {
    start(event) {
      //console.log(event.type, event.target)
    },
    move(event) {
      position.x += event.dx;
      position.y += event.dy;

      event.target.style.transform = `translate(${position.x}px, ${position.y}px)`;
    },
  },
});

// ========  jQuery calls:

jQuery(function () {
  //Change nav contrast:
  function navChangeContrast() {
    $(".darkbg").each(function () {
      var bounding = $(this).get(0).getBoundingClientRect();
      //console.log(bounding.top + " || " + bounding.bottom);

      if (bounding.top - 40 <= 0 && bounding.bottom >= 0) {
        $("#smallNav").addClass("clearnav");
        $(".logo-mini").children("img").attr("src", "/wp-content/themes/masters/assets/img/logo-mini-white.svg");
        // console.log('Element is in the viewport!');
        return false;
      } else {
        $("#smallNav").removeClass("clearnav");
        $(".logo-mini").children("img").attr("src", "/wp-content/themes/masters/assets/img/logo-mini.svg");
        //console.log('Element is NOT in the viewport!');
      }
    });
  }
  $(window).scroll(function () {
    navChangeContrast();
  });

  //MAP
  $(".map .pin").each(function () {
    $(this).attr("data-before", $(this).attr("data"));
  });

  //detailed Map (what we do)
  $(".map-detailed .pin").each(function () {
    $(this).on("click", function () {
      $(".pinContent").hide();
      $(".map-detailed .pin").removeClass("hovered");

      var pinContent = $(this).attr("location");
      $(".pinContent" + "." + pinContent).toggle();
      $(this).toggleClass("hovered");
      //console.log($('.pinContent'+'.'+pinContent));
    });
  });
  // hide modals when clicking away
  $(document).on("click", function (event) {
    var $target = $(event.target);
    if (!$target.closest(".map-detailed .pin").length && $(".pinContent").is(":visible")) {
      $(".pinContent").hide();
      $(".map-detailed .pin").removeClass("hovered");
    }
  });

  //Toggle Mobile Flyout
  $(".hamburgerMenu").on("click", function (event) {
    $(".navFlyout").toggleClass("show", !$(this).hasClass("show"));
  });
  $(".hamburgerMenu.close").on("click", function (event) {
    $(".navFlyout").toggleClass("show", $(this).hasClass("show"));
  });

  //Hide nav on scroll
  var prev = 0;

  var $window = $(window);
  var nav = $("nav#header");
  var smallNav = $("#smallNav");
  var navflyout = $(".navFlyout");

  //Check on load/reload:
  var scrollTop = $window.scrollTop();
  nav.toggleClass("hidden", scrollTop > prev);
  smallNav.toggleClass("shown", scrollTop > prev);
  const newLocal = scrollTop == prev;
  const newLocal_1 = $(".navflyout").hasClass("show");
  navflyout.toggleClass("show", newLocal && newLocal_1);

  //Check on scroll
  $window.on("scroll", function () {
    var scrollTop = $window.scrollTop();
    nav.toggleClass("hidden", scrollTop > prev);
    smallNav.toggleClass("shown", scrollTop > prev);
    const newLocal = scrollTop == prev;
    const newLocal_1 = $(".navflyout").hasClass("show");
    navflyout.toggleClass("show", newLocal && newLocal_1);

    //console.log( "ScrollTop: "+scrollTop);
  });

  //News slider on Home
  $(".news-slide").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  //
  $(".content-slider").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
  });

  //Product Portolfio (Partnerships page)
  $(".product-slide").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // Team: who we are page
  $(".team-slider").slick({
    dots: true,
    infinite: false,
    speed: 300,
    rows: 2,
    slidesPerRow: 4,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          rows: 2,
          slidesPerRow: 3,
          //slidesToShow: 2,
          //slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 792,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          //slidesToShow: 2,
          //slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          //slidesToShow: 1,
          // slidesToScroll: 1
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  //Select2 for forms
  $(".wpcf7-select").select2({
    minimumResultsForSearch: Infinity,
  });

  //draggale map
  //$( ".map" ).draggable({ axis: "x", containment: "#mapWrapper" });

  //END
});
